/** @module csi/widget/ValidationTextArea */
define([
	"dojo/_base/declare",
	"dijit/form/Textarea",
	"./_ErrorMessageMixin",
	"./_InsertNewlineMixin"
], function(declare,Textarea,_ErrorMessageMixin,_InsertNewlineMixin) {
	
	return declare([Textarea, _ErrorMessageMixin, _InsertNewlineMixin], {
		/** @property {boolean} allowResize - allow text area to resize to content (control height through CSS if not) */
		allowResize: false,
		
		/** @property {DOMNode} errorNode - node where to show error message */
		errorNode: null,

		/** @property {string} message - validation message */
		message: "",
		
		/** @property {string} missingMessage - message to display if required value is missing */
		missingMessage: "",
		
		/** @property {boolean} required - set to true if value must not be empty */
		required: false,

		/**
		 * Clear validation error when reset 
		 */
		reset: function() {
			this.inherited(arguments);
			this._setValidState(true);
		},

		/**
		 * @override
		 * Restrict resizing if so configured
		 */
		resize: function() {
			if (this.allowResize) {
				this.inherited(arguments);
			}
		},
		
		/**
		 * Test for validation errors, returning true if valid; otherwise, display error and return false
		 * @return {boolean}
		 */
		validate: function() {
			const valid = !this.required || !!this.value;
			this._setValidState(valid);
			return valid;
		},
		
		/**
		 * Update widget error based on required property and current value
		 * @param {boolean} valid
		 */
		_setValidState: function(valid) {
			this._set("state", valid ? "" : "Error");
			this.set("message", valid ? "" : (this.missingMessage || ""));
		},
		
		/**
		 * @override
		 * Validate after setting value
		 */
		_setValueAttr: function(value) {
			this.inherited(arguments);
			this.validate();
		}
	});
});
